import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/blogArticles';

export default function ArticleCardsSection() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            Latest Articles
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Vigorbuy Spreadsheet Guides & Insights
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Explore our collection of in-depth articles covering everything from beginner tips 
            to advanced shopping strategies — all designed to help you get the most from the 
            Vigorbuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group block rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-lg transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-600">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {article.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap">
                    Read More <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/blog/vigorbuy-spreadsheet-ultimate-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Read Our Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}